module.exports = __webpack_public_path__ + "img/知母.11a7fa36.jpg";